import { render, staticRenderFns } from "./dish-translations-list.vue?vue&type=template&id=b4d04494&scoped=true"
import script from "./dish-translations-list.vue?vue&type=script&lang=js"
export * from "./dish-translations-list.vue?vue&type=script&lang=js"
import style0 from "./dish-translations-list.vue?vue&type=style&index=0&id=b4d04494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d04494",
  null
  
)

export default component.exports